exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-matching-row {\n  border: 1px solid #e0e3e6;\n  border-radius: 7px;\n  padding: 7px;\n  padding-left: 10px;\n  padding-right: 20px;\n  margin-bottom: 15px;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  margin-left: 5px !important;\n}\n\n.input-width .form-group {\n  width: 100%;\n}\n\n.input-width {\n  display: flex;\n  align-items: center;\n}", ""]);

// exports
